import React from "react";
import Card from "../../components/card";
import news1 from "../../assets/newspage1.png";
import news2 from "../../assets/newspage2.png";
import news3 from "../../assets/newspage3.png";
import news4 from "../../assets/newspage4.png";
import news5 from "../../assets/newspage5.png";
import news6 from "../../assets/newspage6.png";
import { Link } from "react-router-dom";

const newsInfo = [
  {
    image: news3,
    category: "Arts",
    title: "Creativity Unleashed: Student Art Exhibition",
    text: "Our talented artists showcased their creativity and artistic skills at our student art exhibition. From paintings to sculptures, their stunning creations left us in awe.",
  },
  {
    image: news5,
    category: "Academics",
    title: "Inspiring Minds: Guest Speaker Series",
    text: "Renowned author [Guest Speaker's Name] shared valuable insights with our students. They discussed the power of storytelling and motivated students to embrace the world of literature and imaginati",
  },
  {
    image: news2,
    category: "Sports",
    title: "Celebrating Team Spirit and Sportsmanship",
    text: "Our annual sports day was a grand success! Students displayed remarkable sportsmanship, teamwork, and enthusiasm. From relay races to friendly competitions, it was a day filled with excitement an",
  },

  {
    image: news4,
    category: "Cultural",
    title: "International Cultural Fair",
    text: "The school came alive with colors, flavors, and traditions from around the world. Our students proudly presented their cultural heritage through performances, food stalls, and interactive displays.",
  },
];

function EventsNews() {
  return (
    <section className="news-wrapper">
      {newsInfo.map((news, idx) => (
        <Link to="h1h1">
          <Card
            key={`${idx}-${news.title}`}
            id={`${idx}-${news.title}`}
            img={news.image}
            title={news.title}
            category={news.category}
            text={news.text}
          />
        </Link>
      ))}
    </section>
  );
}

export default EventsNews;
